import graphQl from '../../../../services/graphQl';
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './profile.store';
import axios, { AxiosResponse } from 'axios';
import * as types from '../mutation-types';
import _ from 'lodash';

// actions
const actions = {
  GET_ENDPOINTS(context: { dispatch: Dispatch; commit: Commit }, params: any) {
    return graphQl
      .query('queryRangeEndpoints')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(types.SET_ENDPOINTS, res.data.data.getEndpoints);
      })
      .catch((error) => console.log('error', error));
  },
  GET_TASK_LIST(
    context: { state: State; dispatch: Dispatch; commit: Commit },
    params: any,
  ) {
    let endpoint = '';
    if (params.endpointName === 'All Endpoints ') {
      endpoint = '';
    } else {
      endpoint = params.endpointName;
    }
    const param = {
      serviceId: params.serviceId,
      endpointName: endpoint,
      pagination: params.pagination,
    };
    graphQl
      .query('getProfileTaskList')
      .params(param)
      .then((res: AxiosResponse) => {
        if (!res.data.data) {
          return;
        }
        context.commit(
          types.SET_TASK_LIST,
          res.data.data.getProfileTaskList.tasks,
        );
        context.commit(
          types.SET_TASK_LIST_TOTAL,
          res.data.data.getProfileTaskList.total,
        );
        return res.data.data.getProfileTaskList.tasks;
      })
      .then((data: any) => {
        if (!data) {
          return;
        }
        if (_.isEmpty(data)) {
          context.dispatch('GET_SEGMENT_LIST', { taskID: data });
        } else {
          context.dispatch('GET_SEGMENT_LIST', { taskID: data[0].id });
        }
      })
      .catch((error) => console.log('error', error));
  },
  GET_SEGMENT_LIST(
    context: { commit: Commit; dispatch: Dispatch },
    params: { taskID: any },
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      graphQl
        .query('getProfileTaskSegmentList')
        .params(params)
        .then((res: AxiosResponse) => {
          if (!res.data.data.getProfileTaskSegmentList) {
            return;
          }
          const { getProfileTaskSegmentList } = res.data.data;

          context.commit(types.SET_SEGMENT_LIST, [
            params.taskID,
            getProfileTaskSegmentList,
          ]);
          if (getProfileTaskSegmentList[0]) {
            context.commit(
              types.SET_CURRENT_SEGMENT,
              getProfileTaskSegmentList[0],
            );
            context.dispatch('GET_SEGMENT_SPANS', {
              segmentId: getProfileTaskSegmentList[0].segmentId,
            });
          } else {
            context.commit(types.SET_CURRENT_SEGMENT, {
              traceIds: [],
            });
            context.commit(types.SET_SEGMENT_SPANS, []);
            context.commit(types.SET_PROFILE_ANALYZATION, []);
          }
          resolve();
        })
        .catch((error) => console.log('error', error));
    });
  },
  GET_SEGMENT_SPANS(
    context: { state: State; commit: Commit; dispatch: Dispatch },
    params: { segmentId: string },
  ) {
    graphQl
      .query('queryProfileSegment')
      .params(params)
      .then((res: AxiosResponse) => {
        const { getProfiledSegment } = res.data.data;
        if (!getProfiledSegment) {
          return;
        }
        context.commit(types.SET_SEGMENT_SPANS, getProfiledSegment.spans);
        if (!(getProfiledSegment.spans && getProfiledSegment.spans.length)) {
          return;
        }
        const index = getProfiledSegment.spans.length - 1 || 0;
        context.commit(types.SET_CURRENT_SPAN, getProfiledSegment.spans[index]);
      })
      .catch((error: any) => {
        console.log('GET_SEGMENT_SPANS api call failed ' + error.message);
      });
  },
  GET_PROFILE_ANALYZE(
    context: { commit: Commit; state: State; dispatch: Dispatch },
    params: {
      segmentId: string;
      timeRanges: Array<{ start: number; end: number }>;
    },
  ) {
    return graphQl
      .query('getProfileAnalyze')
      .params(params)
      .then((res: AxiosResponse) => {
        const { getProfileAnalyze, tip } = res.data.data;
        if (tip) {
          return tip;
        }
        if (!getProfileAnalyze) {
          context.commit(types.SET_PROFILE_ANALYZATION, []);
          return;
        }
        context.commit(types.SET_PROFILE_ANALYZATION, getProfileAnalyze.trees);
      });
  },
  CREATE_PROFILE_TASK(
    context: { commit: Commit; state: State; dispatch: Dispatch },
    param: { startTime: number },
  ) {
    //
    const {
      service,
      endpointName,
      minThreshold,
      monitorDuration,
      dumpPeriod,
      maxSamplingCount,
      monitorTime,
    } = context.state.newTaskFields;
    const creationRequest = {
      serviceId: service.key,
      endpointName: endpointName,
      startTime:
        monitorTime.key === '1' ? param.startTime : new Date().getTime(),
      duration: monitorDuration.key,
      minDurationThreshold: minThreshold,
      dumpPeriod: dumpPeriod.key,
      maxSamplingCount: maxSamplingCount.key,
    };
    return graphQl
      .query('saveProfileTask')
      .params({ creationRequest })
      .then((res: AxiosResponse) => {
        if (
          res.data.data &&
          res.data.data.createTask &&
          res.data.data.createTask.errorReason
        ) {
          return res.data.data.createTask;
        }
        context.commit('SET_TASK_ID', res.data.data.createTask.id);
        return res.data.data.createTask;
      });
  },
  DELETE_PROFILE_TASK(
    context: { commit: Commit; state: State; dispatch: Dispatch },
    param: { taskId: any },
  ) {
    return graphQl
      .query('deleteProfileTask')
      .params(param)
      .then((res: AxiosResponse) => {
        context.commit('SET_TASK_ID', new Date().getTime());
        if (
          res.data.data &&
          res.data.data.profileTask &&
          res.data.data.profileTask.errorReason
        ) {
          return res.data.data.profileTask;
        }
      });
  },
};

export default actions;
